import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {
  clearDashboardLayout,
  isDashboardCustomised,
  readDashboardCardOrder,
  readHiddenCards,
} from "_shared/_views/dashboards/dashboard-card-order";
import { enqueueSnackbar } from "_shared/_providers/snackbars/snackbars";
import { useState } from "react";
import SettingsSection from "users/settings/_views/settings-section";

export const DASHBOARD_RESET_MESSAGE = "Your dashboard is back to the default layout.";

/**
 * The same reset as the dashboard's own cards menu, for a person who cannot find that menu or has
 * hidden the card they wanted back.
 */
export default function DashboardSettingsSection() {
  const [customised, setCustomised] = useState(() =>
    isDashboardCustomised(
      readDashboardCardOrder(globalThis.localStorage),
      readHiddenCards(globalThis.localStorage),
    ),
  );

  const reset = () => {
    clearDashboardLayout(globalThis.localStorage);
    setCustomised(false);
    enqueueSnackbar(DASHBOARD_RESET_MESSAGE, { variant: "success" });
  };

  return (
    <SettingsSection
      description="The order of your dashboard cards, and the cards you hid. This browser keeps them; another browser shows the default layout."
      title="Dashboard"
    >
      <Typography>
        {customised
          ? "You changed the order of your cards or hid some of them."
          : "Your dashboard shows the default layout."}
      </Typography>
      <div>
        <Button disabled={!customised} onClick={reset} variant="outlined">
          Reset to the default layout
        </Button>
      </div>
    </SettingsSection>
  );
}
